/* 4U product cards: badges, anti-stagger grid, instant swatches, hover
   image, image gallery (same colour only) and Quick Add. Loaded once per
   page (cached) by snippets/product-badges.liquid. */
(function(){
  if (window.__fuBadgeInit) return;
  window.__fuBadgeInit = true;

  var CAN_HOVER = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GALLERY_MAX = 12;
  var GALLERY_SPEED = 520;
  var SAVE_DATA = !!(navigator.connection && navigator.connection.saveData);

  /* Run non-urgent work when the browser is idle, so it never competes with page load */
  function idle(fn){
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
    else setTimeout(fn, 400);
  }
  /* Ask for a photo no bigger than the card needs (never more than 900px wide) */
  function fitWidth(el){
    var w = (el && el.clientWidth) || 300;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var px = Math.ceil(w * dpr / 180) * 180;
    return Math.max(360, Math.min(900, px));
  }

  function fuFont(){
    var link = document.querySelector('header nav a, .header nav a, .header__menu a, .menu__item a, header .menu a, header a[href*="/collections"]');
    if (!link) return;
    var cs = getComputedStyle(link);
    var root = document.documentElement;
    if (cs.fontFamily) root.style.setProperty('--fu-badge-font', cs.fontFamily);
    if (cs.fontWeight) root.style.setProperty('--fu-badge-weight', cs.fontWeight);
  }

  function checkCard(card){
    var best = card.querySelectorAll('[data-fu-best]');
    if (!best.length) return;
    var c = card.querySelector('[data-colour-name]');
    var isBlack = !!(c && /onyx|black/i.test(c.textContent));
    best.forEach(function(el){ el.style.display = isBlack ? '' : 'none'; });
  }
  function fuBadges(){ document.querySelectorAll('.product-card').forEach(checkCard); }

  function isSlider(el){
    return !!(el.closest && el.closest('slider-element, .swiper, .splide, .flickity-enabled, [class*="slider"], [class*="carousel"]'));
  }
  function alignGrids(){
    document.querySelectorAll('.product-card').forEach(function(card){
      if (card.__fuAligned) return;
      card.__fuAligned = true;
      if (isSlider(card)) return;
      var cell = card, depth = 0;
      while (cell && cell.parentElement && depth < 4) {
        var parent = cell.parentElement;
        var cs = getComputedStyle(parent);
        var isGrid = cs.display.indexOf('grid') > -1;
        var isWrapFlex = cs.display.indexOf('flex') > -1 && cs.flexWrap === 'wrap' && cs.flexDirection.indexOf('row') === 0;
        if (isGrid || isWrapFlex) {
          if (parent.children.length > 1) { parent.classList.add('fu-grid'); cell.classList.add('fu-grid-item'); }
          return;
        }
        cell = parent; depth++;
      }
    });
  }

  var PRE = {};
  function preload(url){
    if (!url || PRE[url]) return;
    var im = new Image();
    im.decoding = 'async';
    im.src = url;
    PRE[url] = im;
    if (im.decode) im.decode().catch(function(){});
  }
  function preloadCard(card){
    if (!card || card.__fuPre) return;
    card.__fuPre = true;
    card.querySelectorAll('.color-swatch[data-swap-image]').forEach(function(s){ preload(s.getAttribute('data-swap-image')); });
  }

  var PJ = {};
  function handleOf(card){
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var m = a.getAttribute('href').match(/\/products\/([^\/?#.]+)/);
    return m ? m[1] : '';
  }
  function getP(handle){
    if (!handle) return Promise.resolve(null);
    if (!PJ[handle]) {
      PJ[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return PJ[handle];
  }
  function optIndex(p, re){
    var names = p.options || [];
    for (var i = 0; i < names.length; i++) {
      var n = typeof names[i] === 'string' ? names[i] : (names[i].name || '');
      if (re.test(n)) return i;
    }
    return -1;
  }
  function sized(url, w){
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fileKey(u){
    var s = String(u || '').split('?')[0];
    return s.substring(s.lastIndexOf('/') + 1).toLowerCase();
  }
  function handleize(s){ return String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function currentColour(card){
    var active = card.querySelector('.color-swatch.swatch--active[data-swap-colour]');
    if (active) return active.getAttribute('data-swap-colour');
    var c = card.querySelector('[data-colour-name]');
    return c ? c.textContent.trim() : '';
  }
  function variantsForColour(p, ci, colour){
    if (ci < 0 || !colour) return p.variants;
    var key = 'option' + (ci + 1);
    var list = p.variants.filter(function(v){ return String(v[key] || '').toLowerCase() === colour.toLowerCase(); });
    return list.length ? list : p.variants;
  }

  /* Which colour is this card showing? Collection pages render one card per
     colour (e.g. "... - Steel Blue") with no colour label element, so fall
     back to the card's ?variant= link, then the colour named in the title.
     Returns an exact option value from the product whenever possible. */
  function colourFor(card, p, ci){
    var raw = currentColour(card);
    if (ci < 0 || !p || !p.variants) return raw;
    var key = 'option' + (ci + 1);
    var values = [];
    p.variants.forEach(function(v){ var c = v[key]; if (c && values.indexOf(c) === -1) values.push(c); });
    function exact(s){
      s = String(s || '').toLowerCase().trim();
      if (!s) return '';
      for (var i = 0; i < values.length; i++) { if (values[i].toLowerCase() === s) return values[i]; }
      return '';
    }
    var active = card.querySelector('.color-swatch.swatch--active[data-swap-colour]');
    if (active) { var a = exact(active.getAttribute('data-swap-colour')); if (a) return a; }
    var links = card.querySelectorAll('a[href*="variant="]');
    for (var j = 0; j < links.length; j++) {
      if (links[j].closest('.fu-qa, .swatches, .product-card__bottom')) continue;
      var m = (links[j].getAttribute('href') || '').match(/[?&]variant=(\d+)/);
      if (!m) continue;
      for (var k = 0; k < p.variants.length; k++) {
        if (String(p.variants[k].id) === m[1] && p.variants[k][key]) return p.variants[k][key];
      }
    }
    var named = exact(raw);
    if (named) return named;
    var t = card.querySelector('[data-card-title-link], .product-card__title');
    var text = String(t ? t.textContent : '').toLowerCase().replace(/\s+/g, ' ');
    var best = '';
    values.forEach(function(v){ if (text.indexOf(v.toLowerCase()) > -1 && v.length > best.length) best = v; });
    return best || raw;
  }

  /* Every photo that belongs to one colour, in the product's own media order
     (model shots first, athlete / UGC shots last). Photos are matched by the
     #colour_xxx tag in their alt text. Products with no tags and a single
     colour use all of their photos. Products with several colours and no tags
     return nothing, so a card never shows the wrong colour. */
  function colourImages(p, ci, colour){
    var media = (p.media || []).filter(function(m){ return m.media_type === 'image' && m.src; });
    var tagged = media.filter(function(m){ return m.alt && m.alt.indexOf('#') > -1; });
    if (tagged.length) {
      var colourH = handleize(colour);
      if (!colourH) return [];
      return tagged.filter(function(m){
        var tags = m.alt.split('#').pop().toLowerCase().split(',');
        return tags.some(function(t){
          t = t.trim();
          if (t.indexOf(':') > -1) t = t.split(':').pop();
          return t.split('_').pop() === colourH;
        });
      }).map(function(m){ return m.src; });
    }
    if (ci < 0) return media.map(function(m){ return m.src; });
    var colours = {};
    p.variants.forEach(function(v){ colours[String(v['option' + (ci + 1)] || '').toLowerCase()] = true; });
    if (Object.keys(colours).length <= 1) return media.map(function(m){ return m.src; });
    return [];
  }

  /* Hover image = the athlete / UGC shot, which is the LAST photo of the colour. */
  function hoverImageFor(p, ci, colour, shownKey){
    var list = colourImages(p, ci, colour);
    for (var i = list.length - 1; i >= 0; i--) { if (fileKey(list[i]) !== shownKey) return list[i]; }
    return null;
  }

  function mediaBox(card){
    var img = card.querySelector('.product-card__img') || card.querySelector('img');
    if (!img) return null;
    var link = img.closest('.product-card__image-link') || img.parentElement;
    var box = link.parentElement && link.parentElement !== card ? link.parentElement : link;
    return { img: img, link: link, box: box };
  }

  function hideNativeQuickAdd(card){
    card.querySelectorAll('button, a').forEach(function(el){
      var t = (el.textContent || '').trim().toLowerCase();
      if (t === 'choose options' || t === 'quick add' || t === 'add to cart') {
        if (!el.closest('.fu-qa')) el.classList.add('fu-native-qa');
      }
    });
  }

  function updateHoverImage(card, p){
    var mb = mediaBox(card);
    if (!mb) return;
    var hi = mb.link.querySelector('.fu-hover-img');
    var ci = optIndex(p, /colou?r/i);
    var colour = colourFor(card, p, ci);
    var shownKey = fileKey(mb.img.getAttribute('src') || mb.img.currentSrc);
    var src = hoverImageFor(p, ci, colour, shownKey);
    if (!src) {
      if (hi) { hi.classList.remove('is-ready'); hi.__src = ''; hi.removeAttribute('src'); }
      return;
    }
    src = sized(src, fitWidth(mb.link));
    if (!hi) {
      if (getComputedStyle(mb.link).position === 'static') mb.link.style.position = 'relative';
      hi = document.createElement('img');
      hi.className = 'fu-hover-img';
      hi.alt = '';
      hi.setAttribute('aria-hidden', 'true');
      hi.decoding = 'async';
    }
    /* Always keep it as the last child so it sits above the gallery */
    if (mb.link.lastElementChild !== hi) mb.link.appendChild(hi);
    if (hi.__src === src) return;
    hi.__src = src;
    hi.classList.remove('is-ready');
    hi.onload = function(){ if (hi.__src === src) hi.classList.add('is-ready'); };
    hi.src = src;
  }

  /* ---- Image gallery: scroll through every photo of the colour shown ---- */
  function clearGallery(card){
    card.querySelectorAll('.fu-gal, .fu-gal__arrow, .fu-gal__pips').forEach(function(n){ n.remove(); });
    card.classList.remove('fu-gal-on');
    card.classList.remove('fu-gal-used');
    card.__fuGalReset = null;
    card.__fuGalWarm = null;
  }

  /* On screen: quietly fetch the second photo so the first swipe is instant.
     Off screen: the card goes straight back to its first photo. */
  var galIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      var card = en.target;
      card.__fuGalSeen = en.isIntersecting;
      if (en.isIntersecting) {
        if (card.__fuGalWarm) { var warm = card.__fuGalWarm; card.__fuGalWarm = null; warm(); }
      } else if (card.__fuGalReset) {
        card.__fuGalReset(true);
      }
    });
  }, { threshold: 0 }) : null;

  function buildGallery(card, p){
    var img = card.querySelector('.product-card__img');
    if (!img) return;
    var link = img.closest('.product-card__image-link') || img.parentElement;
    if (!link) return;
    var box = link.parentElement && link.parentElement !== card ? link.parentElement : link;

    var ci = optIndex(p, /colou?r/i);
    var colour = colourFor(card, p, ci);
    var shown = img.getAttribute('src') || img.currentSrc || '';
    var shownKey = fileKey(shown);
    var list = colourImages(p, ci, colour);

    /* The photo already on the card always stays first, the rest keep product order */
    var at = -1;
    for (var i = 0; i < list.length; i++) { if (fileKey(list[i]) === shownKey) { at = i; break; } }
    if (at > 0) list = [list[at]].concat(list.slice(0, at), list.slice(at + 1));
    else if (at < 0 && list.length && shown) list = [shown].concat(list);
    list = list.slice(0, GALLERY_MAX);

    var sig = list.map(fileKey).join(',');
    var old = link.querySelector('.fu-gal');
    if (old && old.__sig === sig) return;
    clearGallery(card);
    if (list.length < 2) return;

    if (getComputedStyle(link).position === 'static') link.style.position = 'relative';
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';

    var cs = getComputedStyle(img);
    var gal = document.createElement('div');
    gal.className = 'fu-gal';
    gal.__sig = sig;
    if (cs.objectFit) gal.style.setProperty('--fu-gal-fit', cs.objectFit);
    if (cs.objectPosition) gal.style.setProperty('--fu-gal-pos', cs.objectPosition);

    var track = document.createElement('div');
    track.className = 'fu-gal__track';
    var slideW = fitWidth(link);
    var slides = [];
    list.forEach(function(src, n){
      var s = document.createElement('div');
      s.className = 'fu-gal__slide';
      var im = document.createElement('img');
      im.alt = '';
      im.decoding = 'async';
      im.draggable = false;
      im.addEventListener('load', function(){ im.classList.add('is-in'); });
      if (n === 0) { im.src = shown; if (im.complete) im.classList.add('is-in'); }
      else im.setAttribute('data-src', sized(src, slideW));
      s.appendChild(im);
      track.appendChild(s);
      slides.push(im);
    });
    gal.appendChild(track);
    /* Gallery goes in before the hover image so the hover image stays on top */
    var hover = link.querySelector('.fu-hover-img');
    if (hover) link.insertBefore(gal, hover); else link.appendChild(gal);

    var count = slides.length;
    var idx = -1, want = 0, raf = 0, anim = 0, resetting = false, resetTimer;
    function wrap(n){ return ((n % count) + count) % count; }
    function load(n){
      var im = slides[wrap(n)];
      var src = im.getAttribute('data-src');
      if (src) { im.removeAttribute('data-src'); im.src = src; }
    }
    function loadAll(){ for (var k = 0; k < count; k++) load(k); }
    function setActive(n){
      if (n === idx) return;
      idx = n;
      load(n);
      load(n + 1);
      load(n + 2);
    }
    function stopAnim(){
      if (!anim) return;
      cancelAnimationFrame(anim);
      anim = 0;
      resetting = false;
      track.style.scrollSnapType = '';
    }
    /* The shopper has started scrolling: drop the hover image and show the photos in order */
    function markUsed(){ card.classList.add('fu-gal-used'); }
    /* Our own eased glide. Snapping is paused for the glide so the browser does not
       fight it, then switched back on so swipes still land cleanly. */
    function glide(target, speed, done){
      var from = track.scrollLeft;
      var to = target * track.clientWidth;
      var dist = to - from;
      if (!dist) { if (done) done(); return; }
      if (REDUCED) { track.scrollLeft = to; if (done) done(); return; }
      if (anim) { cancelAnimationFrame(anim); anim = 0; }
      var steps = Math.max(1, Math.round(Math.abs(dist) / (track.clientWidth || 1)));
      var dur = Math.min(speed + (steps - 1) * 90, 800);
      var t0 = 0;
      track.style.scrollSnapType = 'none';
      function step(ts){
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        var e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
        track.scrollLeft = from + dist * e;
        if (k < 1) { anim = requestAnimationFrame(step); }
        else { anim = 0; track.scrollLeft = to; track.style.scrollSnapType = ''; if (done) done(); }
      }
      anim = requestAnimationFrame(step);
    }
    function go(n){
      clearTimeout(resetTimer);
      resetting = false;
      markUsed();
      want = wrap(n);
      load(want);
      load(want + 1);
      load(want - 1);
      glide(want, GALLERY_SPEED);
    }
    /* Back to the default first photo once the shopper is done with this card */
    function reset(instant){
      if (!gal.isConnected) return;
      clearTimeout(settle);
      clearTimeout(resetTimer);
      want = 0;
      card.classList.remove('fu-gal-used');
      if (track.scrollLeft < 2) return;
      resetting = true;
      if (instant || REDUCED) {
        if (anim) { cancelAnimationFrame(anim); anim = 0; }
        track.style.scrollSnapType = 'none';
        track.scrollLeft = 0;
        track.style.scrollSnapType = '';
        resetTimer = setTimeout(function(){ resetting = false; card.classList.remove('fu-gal-used'); }, 120);
        return;
      }
      glide(0, 420, function(){
        resetTimer = setTimeout(function(){ resetting = false; card.classList.remove('fu-gal-used'); }, 120);
      });
    }
    card.__fuGalReset = reset;
    /* Only ONE extra photo is fetched ahead of time, only for cards actually on screen,
       only when the browser is idle, and never when the shopper has data saver on.
       Everything else loads on the first touch or hover. */
    function warm(){
      if (SAVE_DATA) return;
      idle(function(){ if (gal.isConnected) load(1); });
    }
    if (!galIO) warm();
    else if (!card.__fuGalObserved) { card.__fuGalObserved = true; card.__fuGalWarm = warm; galIO.observe(card); }
    else if (card.__fuGalSeen) warm();
    else card.__fuGalWarm = warm;

    track.addEventListener('scroll', function(){
      if (track.scrollLeft > 4 && !resetting) markUsed();
      if (raf) return;
      raf = requestAnimationFrame(function(){
        raf = 0;
        var w = track.clientWidth || 1;
        var n = Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / w)));
        if (n !== idx) { setActive(n); }
      });
    }, { passive: true });
    /* Once a swipe settles, the next arrow press starts from where the card now is */
    var settle;
    track.addEventListener('scroll', function(){
      if (anim || resetting) return;
      clearTimeout(settle);
      settle = setTimeout(function(){ if (idx > -1 && !anim && !resetting) want = idx; }, 160);
    }, { passive: true });
    /* A finger or trackpad always wins over a glide in progress */
    track.addEventListener('touchstart', function(){ clearTimeout(resetTimer); stopAnim(); loadAll(); }, { passive: true });
    track.addEventListener('wheel', function(){ clearTimeout(resetTimer); stopAnim(); }, { passive: true });
    /* Fetch the rest of the photos as soon as the shopper shows interest, so nothing pops in mid-swipe */
    card.addEventListener('pointerenter', loadAll, { once: true });
    card.addEventListener('touchstart', loadAll, { once: true, passive: true });
    /* Desktop: when the mouse leaves, the card glides back to its first photo,
       so the next hover shows the athlete / UGC image again */
    if (CAN_HOVER) {
      card.addEventListener('mouseleave', function(){ reset(false); });
    }

    function arrow(dir){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fu-gal__arrow fu-gal__arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Previous image' : 'Next image');
      b.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="' + (dir < 0 ? 'M7.5 2 3.5 6l4 4' : 'm4.5 2 4 4-4 4') + '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      ['click', 'mousedown', 'pointerdown'].forEach(function(evt){
        b.addEventListener(evt, function(e){
          e.stopPropagation();
          if (evt === 'click') { e.preventDefault(); go(want + dir); }
        });
      });
      box.appendChild(b);
    }
    arrow(-1);
    arrow(1);

    card.classList.add('fu-gal-on');
    idx = 0;
  }

  /* Mobile: touching anywhere outside a card sends that card back to its first photo */
  document.addEventListener('touchstart', function(e){
    var inside = e.target && e.target.closest ? e.target.closest('.product-card') : null;
    document.querySelectorAll('.product-card.fu-gal-used').forEach(function(c){
      if (c !== inside && c.__fuGalReset) c.__fuGalReset(false);
    });
  }, { passive: true });

  function prepGallery(card){
    if (card.__fuGalPrep) return;
    var handle = handleOf(card);
    if (!handle || /gift/i.test(handle)) return;
    card.__fuGalPrep = true;
    idle(function(){
      getP(handle).then(function(p){
        if (!p || !p.variants || !p.variants.length) return;
        buildGallery(card, p);
        if (CAN_HOVER) updateHoverImage(card, p);
      });
    });
  }

  function buildQuickAdd(card, p){
    var mb = mediaBox(card);
    if (!mb) return;
    var qa = mb.box.querySelector('.fu-qa');
    if (!qa) {
      if (getComputedStyle(mb.box).position === 'static') mb.box.style.position = 'relative';
      qa = document.createElement('div');
      qa.className = 'fu-qa';
      qa.innerHTML = '<p class="fu-qa-label">Quick Add</p><div class="fu-qa-sizes"></div><div class="fu-qa-msg" aria-live="polite"></div>';
      ['click', 'mousedown', 'pointerdown'].forEach(function(evt){
        qa.addEventListener(evt, function(e){ e.stopPropagation(); if (evt === 'click') e.preventDefault(); });
      });
      mb.box.appendChild(qa);
    }
    var ci = optIndex(p, /colou?r/i);
    var si = optIndex(p, /size/i);
    var colour = colourFor(card, p, ci);
    if (qa.__colour === colour && qa.__built) return;
    qa.__colour = colour;
    qa.__built = true;
    var wrap = qa.querySelector('.fu-qa-sizes');
    var msg = qa.querySelector('.fu-qa-msg');
    msg.textContent = '';
    wrap.innerHTML = '';
    var vs = variantsForColour(p, ci, colour);
    vs.forEach(function(v){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fu-qa-size';
      var label = si > -1 ? v['option' + (si + 1)] : (vs.length === 1 ? 'Add to cart' : v.title);
      b.textContent = label;
      b.setAttribute('aria-label', 'Add ' + p.title + (colour ? ' ' + colour : '') + ' size ' + label + ' to cart');
      if (!v.available) { b.disabled = true; b.title = 'Sold out'; }
      if (vs.length === 1) b.style.flexBasis = '100%';
      b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); addToCart(v.id, b, label, msg); });
      wrap.appendChild(b);
    });
  }

  function refreshCart(){
    return fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        var old = document.querySelector('cart-drawer');
        if (fresh && old) old.replaceWith(fresh);
        ['cart-count', '.cart-count', '[data-cart-count]'].forEach(function(sel){
          var n = doc.querySelector(sel), o = document.querySelector(sel);
          if (n && o) o.innerHTML = n.innerHTML;
        });
        if (window.theme && window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS) {
          fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'fu-quick-add', cart: cart });
          }).catch(function(){});
        }
        return document.querySelector('cart-drawer');
      })
      .catch(function(){ return document.querySelector('cart-drawer'); });
  }

  function addToCart(id, btn, label, msg){
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    btn.textContent = '...';
    msg.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || 'Could not add'); return j; }); })
      .then(function(){
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.textContent = '✓';
        setTimeout(function(){ btn.classList.remove('is-done'); btn.textContent = label; }, 1400);
        refreshCart().then(function(d){ if (d && typeof d.show === 'function') d.show(); });
      })
      .catch(function(err){
        btn.classList.remove('is-busy');
        btn.textContent = label;
        msg.textContent = (err && err.message) ? err.message : 'Could not add, please try again.';
      });
  }

  function prepCard(card){
    if (!CAN_HOVER || card.__fuQaPrep) return;
    var handle = handleOf(card);
    if (!handle || /gift/i.test(handle)) return;
    card.__fuQaPrep = true;
    getP(handle).then(function(p){
      if (!p || !p.variants || !p.variants.length) return;
      card.classList.add('fu-qa-ready');
      hideNativeQuickAdd(card);
      buildQuickAdd(card, p);
      buildGallery(card, p);
      updateHoverImage(card, p);
    });
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting) { preloadCard(en.target); prepCard(en.target); prepGallery(en.target); io.unobserve(en.target); }
    });
  }, { rootMargin: '400px 0px' }) : null;
  function watchCards(){
    document.querySelectorAll('.product-card').forEach(function(card){
      if (card.__fuWatched) return;
      card.__fuWatched = true;
      if (io) io.observe(card); else { preloadCard(card); prepCard(card); prepGallery(card); }
    });
  }

  document.addEventListener('pointerover', function(e){
    var t = e.target;
    var sw = t && t.closest ? t.closest('.color-swatch[data-swap-image]') : null;
    if (sw) preloadCard(sw.closest('.product-card'));
    if (!CAN_HOVER) return;
    var card = t && t.closest ? t.closest('.product-card') : null;
    if (!card) return;
    prepCard(card);
    var h = handleOf(card);
    if (PJ[h]) PJ[h].then(function(p){ if (p) { buildQuickAdd(card, p); buildGallery(card, p); updateHoverImage(card, p); } });
  }, { passive: true });
  document.addEventListener('touchstart', function(e){
    var sw = e.target && e.target.closest ? e.target.closest('.color-swatch[data-swap-image]') : null;
    if (sw) preloadCard(sw.closest('.product-card'));
  }, { passive: true });

  document.addEventListener('click', function(e){
    var swatch = e.target && e.target.closest ? e.target.closest('.color-swatch[data-swap-variant-id]') : null;
    if (!swatch) return;
    var card = swatch.closest('.product-card');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    var img = card.querySelector('.product-card__img');
    var titleLink = card.querySelector('[data-card-title-link]');
    var colourName = card.querySelector('[data-colour-name]');
    var imageLink = card.querySelector('.product-card__image-link');
    var newImage = swatch.getAttribute('data-swap-image');
    var newColour = swatch.getAttribute('data-swap-colour');
    var newUrl = swatch.getAttribute('data-swap-url');
    var hi = card.querySelector('.fu-hover-img');
    if (hi) { hi.classList.remove('is-ready'); hi.__src = ''; }
    if (img && newImage) {
      img.style.transition = 'none';
      img.style.opacity = '1';
      img.removeAttribute('srcset');
      img.src = newImage;
    }
    if (colourName && newColour) colourName.textContent = newColour;
    if (titleLink && newUrl) titleLink.href = newUrl;
    if (imageLink && newUrl) imageLink.href = newUrl;
    card.querySelectorAll('.color-swatch[data-swap-variant-id]').forEach(function(s){ s.classList.remove('swatch--active'); });
    swatch.classList.add('swatch--active');
    checkCard(card);
    /* Swap the gallery to the new colour's photos straight away */
    clearGallery(card);
    var h = handleOf(card);
    getP(h).then(function(p){
      if (!p) return;
      if (CAN_HOVER) buildQuickAdd(card, p);
      buildGallery(card, p);
      if (CAN_HOVER) updateHoverImage(card, p);
    });
  }, true);

  function run(){ fuFont(); fuBadges(); alignGrids(); watchCards(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', function(){
    document.querySelectorAll('.product-card').forEach(function(c){ c.__fuAligned = false; c.__fuWatched = false; });
    run();
  });
  window.addEventListener('load', run);

  document.addEventListener('click', function(e){
    var card = e.target && e.target.closest ? e.target.closest('.product-card') : null;
    if (card) setTimeout(function(){ checkCard(card); }, 30);
  });

  if (window.MutationObserver) {
    var t;
    new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && !(n.classList.contains('fu-qa') || n.classList.contains('fu-hover-img') || n.classList.contains('fu-gal') || n.classList.contains('fu-gal__arrow')) && (n.classList.contains('product-card') || (n.querySelector && n.querySelector('.product-card')))) {
            clearTimeout(t); t = setTimeout(function(){ fuBadges(); alignGrids(); watchCards(); }, 50);
            return;
          }
        }
      }
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }
})();
